export class CookieConsent {
    collected?: boolean = false;
    analysis?: boolean = false;   // e.g. Google Analytics
    functional?: boolean = false; // e.g. username
    marketing?: boolean = false;  // e.g. Ads
}